export class ServerModel {
  constructor(
    public id: number = 0,
    public name: string = 'unknown',
    public ip: string = 'unknown',
    public domain: string = 'unknown',
    public eventsLifetimeDays: number = 0,
    public deploymentStatus: number = -1,
    public serverType: string = 'unknown',
  ) {
  }
}

